import { Box, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function TorqConnectForm({ onSubmit, guideMode }) {
  const formInitialValues = {
    webhookURL: "",
  };
  const formCheckoutSchema = yup.object().shape({
    webhookURL: yup.string().required("required"),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="webhookURL"
                label="Webhook URL"
                value={values.webhookURL}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.webhookURL && !!errors.webhookURL}
                helperText={touched.webhookURL && errors.webhookURL}
                disabled={guideMode}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
